// import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './routers'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import VueClipboards from 'vue-clipboard2'

Vue.use(VueClipboards)
// Vue.config.ignoredElements = [
//     'wx-open-launch-app',
// ];
Vue.config.productionTip = false
// console.log('======',)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')